/* eslint-disable */
import * as types from './mutation-types';

export default {
  /**
  * Login
  */
  [types.SET_LIST_INVENTORY](state, { list }) {
    state.listInventory = list;
  },
};
